import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import RouterOutlet from './RouterOutlet';
import { theme } from './constants/theme';
import { RootState } from 'store/configureStore';
import { themesList } from './constants/themesList';
import { ThemeList } from 'store/ducks/globalTypes';
import ThemeSelector from './components/ThemeSelector';
import { set_superAdmin } from 'store/ducks/Global/globalSlice';

const App: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { scheme, superAdmin } = useSelector(
    (state: RootState) => state.global,
  );
  const isLoggedIn = !!localStorage.getItem('authToken');

  useEffect(() => {
    if (isLoggedIn && localStorage.getItem('roles') === '"super_user"') {
      dispatch(set_superAdmin(true));
    }
  }, [isLoggedIn, superAdmin, navigate]);

  useEffect(() => {
    if (isLoggedIn && window.location.pathname === '/') {
      if (superAdmin) {
        navigate('/super_admin', { replace: true });
      } else {
        navigate('/working_area', { replace: true });
      }
    }
  }, [isLoggedIn, superAdmin, navigate]);

  return (
    <ThemeSelector theme={scheme as ThemeList}>
      <React.Suspense fallback={<div>Loading</div>}>
        <ConfigProvider
          theme={theme(themesList[scheme] ?? themesList['mainTheme'])}
        >
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <RouterOutlet />
          </QueryParamProvider>
        </ConfigProvider>
      </React.Suspense>
    </ThemeSelector>
  );
};

export default App;
